<template>
  <div class="wiki-pedia">
    <div class="temporary">
      <div class="search">
        <div class="label">临时采集</div>
        <a-input-search
          placeholder="输入维基百科地址进行爬取,爬取结果支持下载"
          enter-button="开始解析"
          size="large"
          v-model="url"
          @search="onSearch"
          :loading="searchLoading"
        />
      </div>
    </div>
    <div class="classification">
      <div class="type-wrap">
        <div class="label">分类采集</div>
        <p>选择分类点击进入 可查看已采集数据和新增采集记录</p>
        <ul>
          <li @click="handleGoto(item)" v-for="(item, index) in types" :key="index">
            <img :src="item.tempIcon" alt="" />
          </li>
          <li @click="$router.push({ name: 'wiki_type' })">
            <img width="100%" height="100%" src="./image/更多.png" alt="" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { queryTempCrawlByUrlApi } from '@/api/TopicCrawl/Wikipedia'
import { querySubjectListApi } from '@/api/TopicCrawl/WiliType'
import stringUtil from '@/utils/string'

export default {
  data() {
    return {
      types: [],
      url: '',
      searchLoading: false
    }
  },
  created() {
    this.querySubjectList()
  },
  methods: {
    onSearch() {
      if (stringUtil.isNull(this.url)) {
        this.$message.error('请数据采集地址')
        return
      }
      this.queryTempCrawlByUrl()
    },

    handleGoto(record) {
      this.$router.push({
        name: 'collectlist',
        query: {
          subjectId: record.subjectId,
          subjectName: record.subjectName,
          type: record.type
        }
      })
    },

    async querySubjectList() {
      let query = {
        pn : 1,
        pageSize:7,
        isDefault:1,
        type:'wiki',
        width:212,
        height:150
      }
      let res = await querySubjectListApi(query)
      let { code, msg, data } = res
      if (code == '200') {
        this.types = data.slice(0, 7)
      } else {
        this.$message.error(msg)
      }
    },

    async queryTempCrawlByUrl() {
      this.searchLoading = true

      let res = await queryTempCrawlByUrlApi({ url: this.url })
      let { extra,code, msg } = res
      if (code == '200') {
        localStorage.setItem('tempCrawl', JSON.stringify(extra));
        this.$router.push({ name: 'wikipedia_info', query: { 'queryType':'tempCrawl'} })
      } else {
        this.$message.error(msg)
      }
      this.searchLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
.wiki-pedia {
  height: 100%;
  background: #F0F2F5;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .temporary {
    flex: 0 0 180px;
    background: #1b2f48;
    background: url('./image/临时搜索.png');
    background-size: 100%;
    position: relative;
    .search {
      position: absolute;
      width: 800px;
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
      .label {
        margin-bottom: 10px;
        color: #fff;
        font-size: 18px;
      }
    }
  }
  .classification {
    position: relative;
    flex: 1;
    .type-wrap {
      position: absolute;
      width: 800px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .label {
        margin-bottom: 10px;
        color: #222;
        font-size: 18px;
        padding-left: 5px;
      }
      p {
        color: #666666;
        padding-left: 5px;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 25%;
          padding: 8px;
          height: 150px;
          cursor: pointer;
          img {
            height: 100%;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
